import React from 'react';
import { Spinner } from 'src/components/spinner';
import { LoaderRoot } from './styles';

type LoaderProps = {
  fadeIn?: boolean;
};

const Loader: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<LoaderProps>
>> = ({ fadeIn = true }) => (
  <LoaderRoot fadeIn={fadeIn}>
    <Spinner size={48} isActive />
  </LoaderRoot>
);

export default Loader;
